<template>
  <div>
    <div v-if="isLoading" class="loading">
      <b-spinner type="grow" label="Spinning" />
    </div>
    <div style="text-align: left; margin: 1rem;">
      <b-row>
        <b-col cols="auto">
          <summary-report-modal
            :status-print="statusPrint"
            :status-shared="statusShared"
            :print-summary-handler="summaryPrint"
          />
        </b-col>
      </b-row>
    </div>
    <b-container id="form" fluid>
      <b-row class="px-3">
        <b-col cols="auto" class="px-1px my-1">
          <!--          <datepicker-->
          <!--                  :minimum-view="'day'"-->
          <!--                  format="d/MM/yyyy"-->
          <!--                  v-model="filter.dateOne"-->
          <!--                  input-class="date-box"-->
          <!--                  clear-button-->
          <!--                  @input="filters(filter)"></datepicker>-->
          <date-picker
            v-model="filter.dateRange"
            type="datetime"
            range
            @close="filters(filter)"
          ></date-picker>
          <!-- <div
            class="datepicker-trigger input-group"
            style="min-width: 150px;"
            @mouseover="activeCloseDate = true"
            @mouseleave="activeCloseDate = false"
          >
            <input
              id="datepicker-trigger"
              class="form-control border-right-0"
              type="text"
              autocomplete="off"
              placeholder="Select dates"
              :value="formatDates(filter.dateOne, filter.dateTwo)"
            />
            <div class="input-group-prepend bg-white">
              <span
                id="basic-addon1"
                class="input-group-text border-left-0 rounded-right bg-white"
              >
                <fa-icon
                  v-show="activeCloseDate"
                  :icon="['fas', 'times']"
                  class="icon"
                  @click="clearDate"
                />
              </span>
            </div>

            <AirbnbStyleDatepicker
              :trigger-element-id="'datepicker-trigger'"
              :mode="'range'"
              :show-shortcuts-menu-trigger="false"
              :fullscreen-mobile="true"
              :date-one="filter.dateOne"
              :date-two="filter.dateTwo"
              @date-one-selected="
                (val) => {
                  filter.dateOne = val;
                }
              "
              @date-two-selected="
                (val) => {
                  filter.dateTwo = val;
                }
              "
              @apply="filters(filter)"
            />
          </div> -->
        </b-col>
        <b-col cols="auto" class="px-1px my-1">
          <multiselect
            v-model="filter.direction"
            style="min-width: 200px;"
            :tabindex="-1"
            :options="direction"
            label="direction"
            track-by="id"
            select-label
            deselect-label="✖"
            selected-label
            placeholder="เส้นทางวิ่ง"
            @close="filters(filter)"
          />
        </b-col>
        <b-col cols="auto" class="px-1px my-1 ">
          <multiselect
            v-model="filter.hospital"
            style="min-width: 200px;"
            :tabindex="-1"
            :options="hospital"
            label="name"
            track-by="id"
            select-label
            deselect-label="✖"
            selected-label
            placeholder="สถานพยาบาล"
            @close="filters(filter)"
          />
        </b-col>
        <b-col cols="auto" class="px-1px my-1">
          <input
            v-model="filter.owner_name"
            type="search"
            class="form-control"
            placeholder="ชื่อเจ้าของ"
            style="min-width: 150px;"
            @input="filter.owner_name === '' ? filters(filter) : null"
            @keyup.enter="filters(filter)"
          />
        </b-col>
        <b-col cols="auto" class="px-1px my-1">
          <input
            v-model="filter.hn"
            type="search"
            class="form-control"
            placeholder="HN"
            style="min-width: 150px;"
            @input="filter.hn === '' ? filters(filter) : null"
            @keyup.enter="filters(filter)"
          />
        </b-col>
        <b-col cols="auto" class="px-1px my-1">
          <input
            v-model="filter.pet_name"
            type="search"
            class="form-control"
            placeholder="ชื่อสัตว์"
            style="min-width: 150px;"
            @input="filter.pet_name === '' ? filters(filter) : null"
            @keyup.enter="filters(filter)"
          />
        </b-col>
        <b-col cols="auto" class="px-1px my-1">
          <input
            v-model="filter.test_name"
            type="search"
            class="form-control"
            placeholder="ชื่อผลตรวจ"
            style="min-width: 150px;"
            @input="filter.pet_name === '' ? filters(filter) : null"
            @keyup.enter="filters(filter)"
          />
        </b-col>
        <b-col cols="auto" class="px-1px my-1">
          <input
            v-model="filter.daily_number"
            type="search"
            class="form-control"
            placeholder="Daily Number"
            style="min-width: 150px;"
            @input="filter.daily_number === '' ? filters(filter) : null"
            @keyup.enter="filters(filter)"
          />
        </b-col>
        <b-col cols="auto" class="px-1px my-1">
          <input
            v-model="filter.ln"
            type="search"
            class="form-control"
            placeholder="LN"
            style="min-width: 150px;"
            @input="filter.ln === '' ? filters(filter) : null"
            @keyup.enter="filters(filter)"
          />
        </b-col>
        <b-col cols="auto" class="px-1px my-1">
          <b-dropdown
            id="dropdown-1"
            text="สถานะการพิมพ์"
            variant="secondary"
            class="m-auto"
          >
            <b-form-group>
              <b-form-checkbox
                v-for="x in statusPrint"
                :key="x.name"
                v-model="filter.is_printed"
                :value="x.value"
                name="status-print-filter"
                stacked
                class="mx-3 my-2"
                @change="$nextTick(() => filters(filter))"
                >{{ x.name }}</b-form-checkbox
              >
            </b-form-group>
          </b-dropdown>
        </b-col>
        <b-col cols="auto" class="px-1px my-1">
          <b-dropdown
            id="dropdown-1"
            text="สถานะการส่ง"
            variant="secondary"
            class="m-auto"
          >
            <b-form-group>
              <b-form-checkbox
                v-for="x in statusShared"
                :key="x.name"
                v-model="filter.is_shared"
                :value="x.value"
                name="status-shared-filter"
                stacked
                class="mx-3 my-2"
                @change="$nextTick(() => filters(filter))"
                >{{ x.name }}</b-form-checkbox
              >
            </b-form-group>
          </b-dropdown>
        </b-col>
        <b-col cols="auto" class="px-1px my-1">
          <b-dropdown
            id="dropdown-1"
            text="ประเภท Lab"
            variant="secondary"
            class="m-auto"
          >
            <b-form-group>
              <b-form-checkbox
                v-for="x in outLabList"
                :key="x.name"
                v-model="filter.is_out_lab"
                :value="x.value"
                name="out-lab-filter"
                stacked
                class="mx-3 my-2"
                @change="$nextTick(() => filters(filter))"
                >{{ x.name }}</b-form-checkbox
              >
            </b-form-group>
          </b-dropdown>
        </b-col>
        <b-col cols="auto" class="px-1px my-1">
          <b-dropdown
            id="dropdown-1"
            text="Test Type"
            variant="secondary"
            class="m-auto"
          >
            <b-form-group>
              <b-form-checkbox
                v-for="x in testTypes"
                :key="x.name"
                v-model="filter.test_type"
                :value="x.id"
                name="test-type-filter"
                stacked
                class="mx-3 my-2"
                @change="$nextTick(() => filters(filter))"
                >{{ x.name }}</b-form-checkbox
              >
            </b-form-group>
          </b-dropdown>
        </b-col>
        <b-col cols="auto" class="px-1px my-auto">
          <b-button
            variant="link"
            block
            class="search-icon"
            @click="filters(filter)"
          >
            <fa-icon icon="search" />
          </b-button>
        </b-col>
        <b-col cols="auto" class="px-1px  my-1">
          <b-button variant="warning" block @click="printSelectedHandler()">
            พิมพ์ผลการตรวจ
          </b-button>
        </b-col>
      </b-row>
    </b-container>
    <!--    <div id="form">-->
    <!--      <form class="flex">-->
    <!--        <div class="select-box">-->
    <!--          <multiselect-->
    <!--            :tabindex="-1"-->
    <!--            v-model="filter.direction"-->
    <!--            :options="direction"-->
    <!--            label="direction"-->
    <!--            track-by="id"-->
    <!--            selectLabel-->
    <!--            deselectLabel="✖"-->
    <!--            selectedLabel-->
    <!--            placeholder="เส้นทางวิ่ง"-->
    <!--            @close="filters(filter)"-->
    <!--          ></multiselect>-->
    <!--        </div>-->
    <!--        <div class="select-box">-->
    <!--          <multiselect-->
    <!--            :tabindex="-1"-->
    <!--            v-model="filter.hospital"-->
    <!--            :options="hospital"-->
    <!--            label="name"-->
    <!--            track-by="id"-->
    <!--            selectLabel-->
    <!--            deselectLabel="✖"-->
    <!--            selectedLabel-->
    <!--            placeholder="สถานพยาบาล"-->
    <!--            @close="filters(filter)"-->
    <!--          ></multiselect>-->
    <!--        </div>-->
    <!--        <div class="date-box">-->
    <!--          <div class="select-box">-->
    <!--            <div-->
    <!--              class="datepicker-trigger input-group"-->
    <!--              @mouseover="activeCloseDate = true"-->
    <!--              @mouseleave="activeCloseDate = false"-->
    <!--            >-->
    <!--              <input-->
    <!--                class="form-control border-right-0"-->
    <!--                type="text"-->
    <!--                autocomplete="off"-->
    <!--                id="datepicker-trigger"-->
    <!--                placeholder="Select dates"-->
    <!--                :value="-->
    <!--                                    formatDates(filter.dateOne, filter.dateTwo)-->
    <!--                                "-->
    <!--              >-->
    <!--              <div class="input-group-prepend bg-white">-->
    <!--                <span-->
    <!--                  class="input-group-text border-left-0 rounded-right bg-white"-->
    <!--                  id="basic-addon1"-->
    <!--                >-->
    <!--                  <fa-icon-->
    <!--                    v-show="activeCloseDate"-->
    <!--                    :icon="['fas', 'times']"-->
    <!--                    class="icon"-->
    <!--                    @click="clearDate"-->
    <!--                  />-->
    <!--                </span>-->
    <!--              </div>-->

    <!--              <AirbnbStyleDatepicker-->
    <!--                :trigger-element-id="'datepicker-trigger'"-->
    <!--                :mode="'range'"-->
    <!--                :showShortcutsMenuTrigger="false"-->
    <!--                :fullscreen-mobile="true"-->
    <!--                :date-one="filter.dateOne"-->
    <!--                :date-two="filter.dateTwo"-->
    <!--                @date-one-selected="-->
    <!--                                    val => {-->
    <!--                                        filter.dateOne = val;-->
    <!--                                    }-->
    <!--                                "-->
    <!--                @date-two-selected="-->
    <!--                                    val => {-->
    <!--                                        filter.dateTwo = val;-->
    <!--                                    }-->
    <!--                                "-->
    <!--                @apply="filters(filter)"-->
    <!--              />-->
    <!--            </div>-->
    <!--          </div>-->
    <!--          &lt;!&ndash; <div class="select-box">-->
    <!--                        <datetime-->
    <!--                            input-class="form-control"-->
    <!--                            class="theme-orange"-->
    <!--                            format="dd-MM-yyyy"-->
    <!--                            v-model="filter.endDate"-->
    <!--                            :min-datetime="filter.startDate"-->
    <!--                            placeholder="end date"-->
    <!--                            v-on:keyup.enter="filters(filter)"-->
    <!--                        ></datetime>-->
    <!--          </div>&ndash;&gt;-->
    <!--        </div>-->
    <!--        <div class="search-box">-->
    <!--          <div class="search">-->
    <!--            <input-->
    <!--              v-model="filter.owner_name"-->
    <!--              type="search"-->
    <!--              class="form-control"-->
    <!--              placeholder="ชื่อเจ้าของ"-->
    <!--              v-on:keyup.enter="filters(filter)"-->
    <!--            >-->
    <!--            <input-->
    <!--              v-model="filter.hn"-->
    <!--              type="search"-->
    <!--              class="form-control"-->
    <!--              placeholder="HN"-->
    <!--              v-on:keyup.enter="filters(filter)"-->
    <!--            >-->
    <!--            <input-->
    <!--              v-model="filter.pet_name"-->
    <!--              type="search"-->
    <!--              class="form-control"-->
    <!--              placeholder="ชื่อสัตว์"-->
    <!--              v-on:keyup.enter="filters(filter)"-->
    <!--            >-->
    <!--            <div class="search-icon" @click="filters(filter)">-->
    <!--              <fa-icon icon="search"/>-->
    <!--            </div>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </form>-->
    <!--    </div>-->
    <b-form-checkbox-group
      id="checkbox-multi-print"
      v-model="multiPrintSelected"
      name="fcheckbox-multi-print"
    >
      <b-table
        :items="items.data"
        :fields="fields"
        striped
        bordered
        responsive
        :tbody-tr-class="rowClass"
      >
        <template slot="เลือก" slot-scope="data">
          <div class="col-center">
            <b-form-checkbox
              :key="data.index"
              :value="data.item.id"
            ></b-form-checkbox>
          </div>
        </template>
        <template slot="no" slot-scope="data">
          <div class="col-right">{{ data.index + items.from }}</div>
        </template>
        <template slot="LN" slot-scope="data">
          <div class="col-right">
            <a
              @click="
                goResultDetail(
                  data.item.id,
                  data.item.animal_id,
                  data.item.hospital_id,
                  true
                )
              "
            >
              <u>{{ data.item.ln }}</u>
            </a>
          </div>
        </template>
        <template slot="เส้นทางวิ่ง" slot-scope="data">
          <div class="col-left">
            {{
              data.item.direction_info
                ? data.item.direction_info.direction.direction
                : ""
            }}
          </div>
        </template>
        <template slot="วันที่สั่งตรวจ" slot-scope="data">
          <div class="col-center">{{ data.item.order_date }}</div>
        </template>
        <template slot="URGENT" slot-scope="data">
          <div
            :class="{
              'text-red': data.item.emergency_level == 1 ? true : false,
              'text-orange':
                data.item.emergency_level == 1
                  ? false
                  : data.item.urgency_hospital_type == 'ปกติ'
                  ? false
                  : true,
              'col-left': true,
            }"
          >
            {{
              data.item.emergency_level == 1 ||
              data.item.urgency_hospital_type == "ด่วน"
                ? `ด่วนพิเศษ ${
                    data.item.sending_time
                      ? "(" + data.item.sending_time + ")"
                      : ""
                  }`
                : data.item.urgency_hospital_type
            }}
          </div>
        </template>
        <template slot="AN" slot-scope="data">
          <div class="col-right">{{ data.item.an }}</div>
        </template>
        <template slot="ชื่อสถานพยาบาล" slot-scope="data">
          <div class="col-left">
            <a @click="goHospitalPage(data.item.hospital_id)">
              <u>{{ data.item.hospital_name }}</u>
            </a>
          </div>
        </template>
        <template slot="ชื่อเจ้าของ" slot-scope="data">
          <div class="col-left">{{ data.item.owner_name }}</div>
        </template>
        <template slot="ชื่อสัตว์" slot-scope="data">
          <div class="col-left">
            <a
              @click="goAnimalPage(data.item.animal_id, data.item.hospital_id)"
            >
              <u>{{ data.item.animal_name }}</u>
            </a>
          </div>
        </template>
        <template slot="วันที่เสร็จสิ้น" slot-scope="data">
          <template v-if="data.item.status_id == 5">
            <div class="col-center">
              {{
                data.item.latest_approve
                  ? data.item.latest_approve.created_at
                  : ""
              }}
            </div>
          </template>
          <template v-else>
            <div class="col-center" style="color: red;">ยังไม่เสร็จสิ้น</div>
          </template>
        </template>
        <template slot="ผู้อนุมัติ" slot-scope="data">
          <div class="col-left">
            {{
              data.item.latest_approve ? data.item.latest_approve.user.name : ""
            }}
          </div>
        </template>
        <template slot="สถานะการส่ง" slot-scope="data">
          <fa-icon
            v-if="!data.item.is_shared"
            :icon="['fas', 'times']"
            class="icon"
            style="cursor: default"
          />
          <fa-icon
            v-else
            :icon="['fas', 'check']"
            class="icon"
            style="cursor: default"
          />
        </template>
        <template slot="ส่งผลตรวจ" slot-scope="data">
          <fa-icon
            :icon="['fas', 'share-square']"
            class="icon"
            @click="showSharedModal(data.item)"
          />
        </template>
        <template slot="พิมพ์(ครั้ง)" slot-scope="data">
          <fa-icon
            :icon="['fas', 'print']"
            class="icon"
            @click="printReport(data.item.id)"
          />
          ( {{ data.item.printed_count }} )
        </template>
        <template slot="ดูผล" slot-scope="data">
          <fa-icon
            :icon="['fas', 'eye']"
            class="icon"
            @click="previewReport(data.item.id)"
          />
        </template>
        <template slot="SPP" slot-scope="data">{{
          data.item.specie_name === "อื่นๆ"
            ? data.item.other_specie
            : data.item.specie_name
        }}</template>
        <template slot="ลบ" slot-scope="data">
          <b-button
            :disabled="!permissions.canDelete"
            variant="danger"
            @click="deleteReportHandler(data.item.id)"
            >ลบ</b-button
          >
        </template>
      </b-table>
    </b-form-checkbox-group>
    <div v-if="items.data ? items.data.length <= 0 : true">ไม่พบข้อมูล</div>
    <b-pagination
      v-model="items.current_page"
      size="md"
      :total-rows="items.total"
      :per-page="items.per_page"
      @input="getDataPerPage(items.current_page)"
    />
    <b-modal
      id="sharedModal"
      ref="sharedModal"
      centered
      title="ส่งรายงานผลตรวจ"
      ok-variant="success"
      ok-title="บันทึก"
      cancel-title="ยกเลิก"
      size="xl"
    >
      <div class="modal-body">
        <b-container fluid>
          <b-row class="text-center">
            <b-col md="4" class="py-3"
              >LN - {{ sharedSelected ? sharedSelected.ln : "" }}</b-col
            >

            <b-col md="4" class="py-3">{{
              sharedSelected ? sharedSelected.hospital_name : ""
            }}</b-col>

            <b-col md="4" class="py-3">
              {{
                sharedSelected ? sharedSelected.latest_approve.created_at : ""
              }}
            </b-col>
          </b-row>
        </b-container>
        <h5 class="left bold">วิธีการส่งผล</h5>
        <div v-if="sharedSelected" class="table-responsive">
          <b-form-group>
            <b-form-checkbox-group
              id="selected-method-checkbox"
              v-model="selectedMethods"
              name="selected-method-checkbox"
            >
              <table class="table">
                <tbody>
                  <template v-for="method in sharedSelected.contactTypes">
                    <tr :key="method.id">
                      <template>
                        <!-- <td>
                          <b-form-checkbox :value="method.type_name" />
                        </td>-->
                        <td style="padding-right: 2rem;" class="m-auto">
                          {{ method.type_name | convertContactTypeName }}
                        </td>
                        <td width="40%" class="m-auto">
                          <div>
                            <multiselect
                              v-if="
                                method.type_name !== 'line_id' &&
                                  method.contacts.length > 0
                              "
                              v-model="contactSelected[method.type_name]"
                              style="min-width: 200px;"
                              placeholder="เลือกส่งผลตรวจ"
                              label="value"
                              track-by="value"
                              :options="method.contacts"
                              :multiple="true"
                              :tabindex="-1"
                              :max-height="1500"
                              @input="
                                selectedContactMultipleHandler(
                                  $event,
                                  method.type_name
                                )
                              "
                            >
                              <template
                                slot="option"
                                slot-scope="props"
                                style="display: flex; flex-direction: row;"
                              >
                                <!--                                            <div style="justify-content: space-between">-->

                                <span class="option__title">
                                  {{ props.option.value }}
                                  <fa-icon
                                    v-if="props.option.has_shared"
                                    :icon="['fas', 'check']"
                                    class="icon"
                                    style="cursor: default; color: #42b983;"
                                  />
                                </span>
                                <!--                                            </div>-->
                              </template>
                              <!--                                        <template slot="option" slot-scope="props"><img class="option__image" :src="props.option.value" alt="No Man’s Sky">-->
                              <!--                                            <div class="option__desc"><span class="option__title">{{ props.option.title }}</span><span class="option__small">{{ props.option.desc }}</span></div>-->
                              <!--                                        </template>-->
                            </multiselect>
                          </div>

                          <!--                      <b-form-select-->
                          <!--                              v-if="method.type_name !== 'line_id'"-->
                          <!--                             :options="method.contacts"-->
                          <!--                              value-field="value"-->
                          <!--                              text-field="value"-->
                          <!--                              v-model="contactSelected[method.type_name]"-->
                          <!--                      ></b-form-select>-->
                        </td>
                        <td class="m-auto">
                          <div
                            v-if="
                              !sharedSelected.sharedHistory.find(
                                (history) =>
                                  history.contact_type_id === method.id
                              )
                            "
                            style="color: #f00"
                          >
                            ยังไม่ได้รายงาน
                          </div>
                          <div v-else style="color: #42b983;">
                            รายงานครบแล้ว
                          </div>
                        </td>
                        <td>
                          <!--                                <b-form-group>-->
                          <!--                                    <b-form-radio-group-->
                          <!--                                            v-model="shareMethodSelect[method.type_name]"-->
                          <!--                                            :options="method.share_methods"-->
                          <!--                                    >-->
                          <!--                                    </b-form-radio-group>-->
                          <!--                                </b-form-group>-->
                          <b-form-group label>
                            <b-form-checkbox-group
                              id="checkbox-group-2"
                              v-model="shareMethodSelect[method.type_name]"
                              name="flavour-2"
                              @change="
                                selectContactHandler($event, method.type_name)
                              "
                            >
                              <b-form-checkbox
                                v-for="shareMethod in method.share_methods"
                                :key="shareMethod"
                                :value="shareMethod"
                                >{{ shareMethod }}</b-form-checkbox
                              >
                            </b-form-checkbox-group>
                          </b-form-group>
                        </td>
                        <!-- <td>
                          <b-btn
                            class=""
                            variant="success"
                            @click="shared(method.type_name, method)"
                          >
                            ส่งผลตรวจ
                          </b-btn>
                        </td>-->
                      </template>
                    </tr>
                  </template>
                </tbody>
              </table>
            </b-form-checkbox-group>
          </b-form-group>
        </div>
        <div style="text-align:center;">
          <b-btn class variant="success" @click="shared()">ส่งผลตรวจ</b-btn>
          <!--          <div-->
          <!--            :key="method.id"-->
          <!--            v-for="method in sharedSelected.contactTypes"-->
          <!--            class="emergency-box ml-4"-->
          <!--          >-->
          <!--            <b-container>-->
          <!--              <b-row style="padding: 0.5rem;">-->
          <!--                <b-col class="left">-->
          <!--                  <b-checkbox-group v-model="contactCheck">-->
          <!--                    <b-input-group>-->
          <!--                      <b-input-group-prepend is-text>-->
          <!--                        <b-form-checkbox-->
          <!--                          :value="method.type_name"-->
          <!--                          :disabled="method.contacts.length <= 0"-->
          <!--                        >{{method.type_name | convertContactTypeName}}</b-form-checkbox>-->
          <!--                      </b-input-group-prepend>-->
          <!--                      <b-form-select-->
          <!--                              v-if="method.type_name !== 'line_id'"-->
          <!--                              :disabled="!isContactCheck(method.type_name, method.contacts)"-->
          <!--                             :options="method.contacts"-->
          <!--                              @change="onSelectContact($event, method.type_name)"-->
          <!--                      ></b-form-select>-->
          <!--                      <div>-->
          <!--                        <b-btn class="float-right ml-2" variant="success" @click="shared">ส่งผลตรวจ</b-btn>-->
          <!--                      </div>-->
          <!--                    </b-input-group>-->
          <!--                  </b-checkbox-group>-->

          <!--                  &lt;!&ndash; <label class="check-box emer-check-box">-->
          <!--                    <input type="checkbox">-->
          <!--                    {{ method.type_name | convertContactTypeName }}-->
          <!--                    <span-->
          <!--                      class="checkmark"-->
          <!--                    ></span>-->
          <!--                  </label>-->
          <!--                </b-col>-->

          <!--                <b-col>-->
          <!--                  <b-form-select v-model="selected" :options="options"/>-->
          <!--                  <input-->
          <!--                    :input-class="{-->
          <!--                                            'form-control': true,-->
          <!--                                            'border-right-0': true-->
          <!--                                        }"-->
          <!--                    type="text"-->
          <!--                    class="theme-orange datepicker-trigger input-group"-->
          <!--                    style="width: auto !important;"-->
          <!--                  >&ndash;&gt;-->
          <!--                </b-col>-->
          <!--              </b-row>-->
          <!--            </b-container>-->
          <!--          </div>-->
        </div>
        <h5 class="left bold">ประวัติล่าสุด 10 รายการ</h5>
        <div
          v-if="sharedSelected"
          class="row"
          style="height: 300px; overflow-y: scroll;"
        >
          <div class="col">
            <table class="table w-100 text-left">
              <tr>
                <th>ผู้ใช้</th>
                <th>ประเภทส่ง</th>
                <th>ข้อมูลการส่ง</th>
                <th>ประเภทไฟล์ส่ง</th>
                <th>เวลาการส่ง</th>
              </tr>
              <template
                v-for="(history, index) of sharedSelected.sharedHistory"
              >
                <tr :key="index">
                  <td>{{ history.user ? history.user.name : "-" }}</td>
                  <td>
                    {{
                      history.contact_type
                        ? history.contact_type.type_name
                        : "-"
                    }}
                  </td>
                  <td>{{ history.value ? history.value : "-" }}</td>
                  <td>{{ history.shared_type ? history.shared_type : "-" }}</td>
                  <td>{{ history.created_at ? history.created_at : "-" }}</td>
                </tr>
              </template>
            </table>
          </div>
        </div>
      </div>
      <div slot="modal-footer" class="w-100">
        <!--        <b-btn class="float-right ml-2" variant="success" @click="shared">ส่งผลตรวจ</b-btn>-->
        <b-btn class="float-right" variant="secondary" @click="hideSharedModal"
          >ยกเลิก</b-btn
        >
      </div>
    </b-modal>
    <notifications group="alert" position="bottom right" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import moment from "moment-timezone";
import format from "date-fns/format";
import printJS from "print-js";
import Datepicker from "vuejs-datepicker";
import * as axios from "axios";
import SummaryReportModal from "./SummaryReportModal";

export default {
  name: "ReportTable",
  components: {
    // Datepicker
    SummaryReportModal,
  },
  async created() {
    // var today = moment.tz("Asia/Bangkok").format("YYYY-MM-DD");
    // console.log(today);

    // this.filters(this.filter);

    this.permissions.canDelete = await this.checkPermission({
      type: "report",
      mod: "can_delete",
    });

    this.permissions.canView = await this.checkPermission({
      type: "report",
      mod: "can_view",
    });

    this.permissions.canPrint = await this.checkPermission({
      type: "report",
      mod: "can_print",
    });

    this.permissions.canShared = await this.checkPermission({
      type: "report",
      mod: "can_share",
    });
  },
  mounted() {
    this.outLabList = [
      ...this.outLabList,
      // ...this.testTypes.map((testType) => ({
      //   name: testType.name,
      //   value: testType.id,
      // })),
    ];
    this.filter.test_type = [...this.testTypes.map((testType) => testType.id)];

    var today = moment.tz("Asia/Bangkok").format("YYYY-MM-DD");
    if (!this.filter.dateOne) {
      this.filter.dateOne = today;
    }
    if (!this.filter.dateTwo) {
      this.filter.dateTwo = today;
    }

    var todayRange = moment.tz("Asia/Bangkok");
    this.filter.dateRange = [
      todayRange
        .set("hour", 0)
        .set("minute", 0)
        .set("second", 0)
        .toDate(),
      todayRange
        .set("hour", 23)
        .set("minute", 59)
        .set("second", 59)
        .toDate(),
    ];

    this.filter.page_no = 1;
    this.filters(this.filter);

    this.setRejectReason();
    this.setSharedMethod();
  },
  computed: {
    ...mapGetters({
      items: "Order/getDataFromFilter",
      direction: "Direction/getAll",
      hospital: "Hospital/getAll",
      status: "Status/getAll",
      sharedMethod: "SharedMethod/getAll",
      getFilter: "Order/getReportFilter",
      testTypes: "Test/getTestType",
    }),
    filter: {
      get() {
        return this.getFilter;
      },
      set(value) {
        this.setReportFilter(value);
      },
    },
  },

  data() {
    return {
      selectedMethods: [],
      activeCloseDate: false,
      fields: [
        // "Daily Number",
        "เลือก",
        { key: "daily_number", label: "Daily NO." },
        "LN",
        "เส้นทางวิ่ง",
        // "วันที่สั่งตรวจ",
        // A column that needs custom formatting
        "URGENT",
        "AN",
        "ชื่อสถานพยาบาล",
        // A regular column
        "ชื่อเจ้าของ",
        // A regular column
        "ชื่อสัตว์",
        "SPP",
        "วันที่เสร็จสิ้น",
        "ผู้อนุมัติ",
        // "รายการตรวจ",
        // "สถานะ",
        // "ส่ง",
        "สถานะการส่ง",
        // A virtual column made up from two fields
        // "APPROVE",
        "ส่งผลตรวจ",
        "พิมพ์(ครั้ง)",
        "ดูผล",
        "ลบ",
      ],
      permissions: {
        canView: false,
        canPrint: false,
        canShared: false,
        canDelete: false,
      },
      outLabList: [
        { name: "In Lab", value: "inLab" },
        { name: "Out Lab", value: "outLab" },
        { name: "ไม่ระบุ", value: "null" },
      ],
      // filter: {
      //   page_no: "1",
      //   direction: null,
      //   hospital: null,
      //   owner_name: null,
      //   pet_name: null,
      //   hn: null,
      //   dateOne: "",
      //   dateTwo: "",
      //   status_id: "5",
      //   receive: true,
      //   daily_number: '',
      // },
      dateFormat: "D/MM/YYYY",
      reasonSelect: "",
      reason: "",
      selectedLn: null,
      sharedSelected: null,
      contactCheck: [],
      contactSelected: [],
      shareMethodSelect: {},
      isLoading: false,
      statusPrint: [
        {
          name: "พิมพ์แล้ว",
          value: "print",
        },
        {
          name: "ยังไม่พิมพ์",
          value: "notPrint",
        },
      ],
      statusShared: [
        {
          name: "ส่งแล้ว",
          value: "shared",
        },
        {
          name: "ยังไม่ส่ง",
          value: "notShared",
        },
      ],
      multiPrintSelected: [],
    };
  },
  methods: {
    selectedContactMultipleHandler(value, method) {
      this.$forceUpdate();
    },
    selectContactHandler(value, typeName) {
      if (value.length === 0) {
        this.selectedMethods = this.selectedMethods.filter(
          (selectedMethod) => selectedMethod !== typeName
        );
      } else {
        this.selectedMethods = [
          ...new Set([...this.selectedMethods, typeName]),
        ];
      }
    },
    // eslint-disable-next-line
    rowClass(item, type) {
      if (item.emergency_level == 1) {
        return "highlight";
      } else {
        return;
      }
    },
    async summaryPrint(filter) {
      let filters =
        // `?startDate=${filter.dateOne || ""}` +
        `?startDate=${moment(filter.dateRange[0]).format(
          "YYYY-MM-DD HH:mm:ss"
        ) || ""}` +
        // `&endDate=${filter.dateTwo || filter.dateOne || ""}` +
        `&endDate=${moment(filter.dateRange[1]).format("YYYY-MM-DD HH:mm:ss") ||
          moment(filter.dateRange[0]).format("YYYY-MM-DD HH:mm:ss") ||
          ""}` +
        `&contact_type_id=${filter.contact_type_id.join(",")}` +
        `&status_id=${filter.status_id.join(",")}`;

      if (filter.is_shared.length === 1) {
        filters += `&is_shared=${
          filter.is_shared[0] === "shared" ? true : false
        }`;
      }

      if (filter.is_printed.length === 1) {
        filters += `&is_printed=${
          filter.is_printed[0] === "print" ? true : false
        }`;
      }

      filters += `&is_out_lab=${filter.is_out_lab.join(",")}`;
      filters += `&test_type=${filter.test_type.join(",")}`;
      // `&hospital=${this.filter.hospital ? this.filter.hospital.id : ''}` +
      // `&ownerName=${this.filter.owner_name || ''}` +
      // `&animalName=${this.filter.pet_name || ''}` +
      // `&dn=${this.filter.daily_number || ''}`
      printJS({
        printable: `${process.env.VUE_APP_IP}print-report-summary${filters}`,
        type: "pdf",
        showModal: true,
      });
    },
    ...mapActions({
      printSummary: "Result/printSummary",
      filterOrder: "Order/filterData",
      // setAll: "Order/setAll",
      setResult: "Result/setResult",
      setAnimalData: "Animal/setData",
      setCustomerData: "Hospital/setData",
      setReadOnly: "Order/setReadOnly",
      setRejectReason: "RejectReason/setAll",
      setCancelReason: "CancelReason/setAll",
      setSharedMethod: "SharedMethod/setAll",
      sharedReport: "Order/sharedReport",
      countPrinted: "Order/countPrinted",
      checkPermission: "Order/checkPermission",
      deleteReport: "Order/deleteReport",
      setReportFilter: "Order/setReportFilter",
      setAdding: "History/setAdding",
      multiprint: "Result/multiprint",
    }),
    // eslint-disable-next-line vue/no-dupe-keys
    async permission(type, mod) {
      let permission = await this.checkPermission({
        type: type,
        mod: mod,
      });

      if (!permission) {
        this.$notify({
          group: "alert",
          title: "มีข้อผิดพลาดบางอย่าง",
          text: permission,
          position: "bottom right",
          type: "error",
        });
        return false;
      }
      return true;
    },
    async deleteReportHandler(id) {
      let permission = await this.permission("report", "can_delete");

      if (permission) {
        this.$bvModal
          .msgBoxConfirm("ยืนยันการลบข้อมูล.", {
            title: "คุณต้องการที่จะลบใช่หรือไม่",
            size: "sm",
            buttonSize: "sm",
            okVariant: "danger",
            okTitle: "ลบ",
            cancelTitle: "ยกเลิก",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true,
          })
          .then(async (value) => {
            if (value) {
              let res = await this.deleteReport(id);
              if (res) {
                this.filters(this.filter);
              }
            }
          })
          .catch((err) => {
            // An error occurred
          });
      }
    },
    formatDates(dateOne, dateTwo) {
      let formattedDates = "";
      if (dateOne) {
        formattedDates = format(dateOne, this.dateFormat);
      }
      if (dateTwo) {
        formattedDates += " - " + format(dateTwo, this.dateFormat);
      }
      return formattedDates;
    },
    clearDate() {
      this.filter.dateOne = "";
      this.filter.dateTwo = "";
      this.filters(this.filter);
    },

    async goResultDetail(idOut, idAnimal, idHospital, readOnly) {
      if (this.$store.state.isLoading) {
        return;
      }

      this.$store.state.isLoading = true;
      let permission = await this.permission("report", "can_view");
      if (permission) {
        this.$store.state.isLoading = true;
        await this.setResult(idOut);
        await this.setAnimalData(idAnimal);
        await this.setCustomerData(idHospital);
        this.$store.state.isLoading = false;
        this.setReadOnly(readOnly);
        this.$router.push({
          name: "result-detail",
          params: { read: readOnly },
        });
      }
      this.$store.state.isLoading = false;
    },
    async filters(obj) {
      let val = {};
      // if (obj.dateTwo == "") {
      if (obj.dateRange.length <= 1) {
        val = {
          page_no: obj.page_no != null ? obj.page_no : "1",
          direction_id: obj.direction != null ? obj.direction.id : "",
          hospital_id: obj.hospital != null ? obj.hospital.id : "",
          owner_name: obj.owner_name != null ? obj.owner_name : "",
          pet_name: obj.pet_name != null ? obj.pet_name : "",
          hn: obj.hn != null ? obj.hn : "",
          // start_date: obj.dateOne
          //   ? moment(obj.dateOne).format("YYYY-MM-DD")
          //   : "",
          // end_date: obj.dateOne ? moment(obj.dateOne).format("YYYY-MM-DD") : "",
          start_date: obj.dateRange[0]
            ? moment(obj.dateRange[0]).format("YYYY-MM-DD HH:mm:ss")
            : "",
          end_date: obj.dateRange[0]
            ? moment(obj.dateRange[0]).format("YYYY-MM-DD HH:mm:ss")
            : "",
          status_id: obj.status_id,
          receive: true,
          daily_number: obj.daily_number != null ? obj.daily_number : "",
          ln: obj.ln != null ? obj.ln : "",
          is_printed: obj.is_printed,
          is_shared: obj.is_shared,
          includingApprove: obj.includingApprove,
          is_out_lab: obj.is_out_lab ? obj.is_out_lab : null,
          contact_type_id: obj.contact_type_id,
          test_name: obj.test_name,
          test_type: obj.test_type ? obj.test_type : null,
          page_type: "report",
        };
      } else {
        val = {
          page_no: obj.page_no != null ? obj.page_no : "1",
          direction_id: obj.direction != null ? obj.direction.id : "",
          hospital_id: obj.hospital != null ? obj.hospital.id : "",
          owner_name: obj.owner_name != null ? obj.owner_name : "",
          pet_name: obj.pet_name != null ? obj.pet_name : "",
          hn: obj.hn != null ? obj.hn : "",
          // start_date: obj.dateOne
          //   ? moment(obj.dateOne).format("YYYY-MM-DD")
          //   : "",
          // end_date: obj.dateTwo ? moment(obj.dateTwo).format("YYYY-MM-DD") : "",
          start_date: obj.dateRange[0]
            ? moment(obj.dateRange[0]).format("YYYY-MM-DD HH:mm:ss")
            : "",
          end_date: obj.dateRange[1]
            ? moment(obj.dateRange[1]).format("YYYY-MM-DD HH:mm:ss")
            : "",
          status_id: obj.status_id,
          receive: true,
          daily_number: obj.daily_number != null ? obj.daily_number : "",
          ln: obj.ln != null ? obj.ln : "",
          is_printed: obj.is_printed,
          is_shared: obj.is_shared,
          includingApprove: obj.includingApprove,
          contact_type_id: obj.contact_type_id,
          test_name: obj.test_name,
          is_out_lab: obj.is_out_lab ? obj.is_out_lab : null,
          test_type: obj.test_type ? obj.test_type : null,
          page_type: "report",
        };
      }
      this.isLoading = true;
      await this.filterOrder(val);
      this.isLoading = false;
    },
    async showSharedModal(item) {
      if (this.$store.state.isLoading) {
        return;
      }

      this.$store.state.isLoading = true;
      let permission = await this.permission("report", "can_share");

      if (permission) {
        this.sharedSelected = item;
        let defaultShare = this.sharedSelected.contactTypes.filter((contact) =>
          contact.contacts.find((method) => method.default)
        );

        defaultShare.forEach((contact) => {
          this.contactSelected[contact.type_name] = contact.defaultContact;
        });

        this.selectedMethods = [];
        this.sharedSelected.contactTypes.forEach((method) => {
          if (method.default_types.length > 0) {
            this.selectedMethods.push(method.type_name);
          }
          this.shareMethodSelect = {
            ...this.shareMethodSelect,
            [method.type_name]: method.default_types,
          };
        });

        // this.selectedMethods = Object.keys(this.shareMethodSelect)

        this.$refs.sharedModal.show();
        this.$store.state.isLoading = false;
        this.$forceUpdate();
      }
      this.$store.state.isLoading = false;
    },
    hideSharedModal() {
      this.sharedSelected = null;
      this.$refs.sharedModal.hide();
    },
    async shared() {
      let payloads = [];

      for (let selectedMethod of this.selectedMethods) {
        let contact = this.sharedSelected.contactTypes.find(
          (con) => con.type_name === selectedMethod
        );
        let payload = {
          type: selectedMethod,
        };
        if (selectedMethod !== "line_id") {
          // if (!this.contactSelected[selectedMethod]) {
          //   this.$notify({
          //     group: 'alert',
          //     title: 'ส่งผลตรวจผิดพลาด',
          //     text: 'โปรดเลือกปลายทางในการรายงานผล',
          //     position: 'bottom right',
          //     type: 'error'
          //   });
          //   this.$refs.sharedModal.show();
          //   return;
          // }
          // if (this.contactSelected[selectedMethod].length <= 0) {
          //     this.$notify({
          //         group: 'alert',
          //         title: 'ส่งผลตรวจผิดพลาด',
          //         text: 'โปรดเลือกปลายทางในการรายงานผล',
          //         position: 'bottom right',
          //         type: 'error'
          //     });
          //     this.$refs.sharedModal.show();
          //     return;
          // }

          if (typeof this.shareMethodSelect[selectedMethod] === "string") {
            this.shareMethodSelect[selectedMethod] = [
              this.shareMethodSelect[selectedMethod],
            ];
          }
          payload = {
            ...payload,
            value: this.contactSelected[selectedMethod],
          };
        }

        if (contact.share_methods.length > 0) {
          if (!this.shareMethodSelect[selectedMethod]) {
            this.$notify({
              group: "alert",
              title: "ส่งผลตรวจผิดพลาด",
              text: "โปรดเลือกรูปแบบไฟล์ในการรายงาน",
              position: "bottom right",
              type: "error",
            });
            this.$refs.sharedModal.show();
            return;
          }

          // if (selectedMethod !== "line") {
          if (this.shareMethodSelect[selectedMethod].length <= 0) {
            this.$notify({
              group: "alert",
              title: "ส่งผลตรวจผิดพลาด",
              text: "โปรดเลือกรูปแบบไฟล์ในการรายงาน",
              position: "bottom right",
              type: "error",
            });
            this.$refs.sharedModal.show();
            return;
          }
          // }

          payload = {
            ...payload,
            method: this.shareMethodSelect[selectedMethod],
          };
        }

        payloads.push(payload);
      }

      this.contactSelected = [];
      this.sharedSelected.contactTypes.forEach((contact) => {
        this.shareMethodSelect[contact.type_name] = [];
      });

      this.selectedMethods = [];

      this.$refs.sharedModal.hide();
      this.isLoading = true;

      let res = await this.sharedReport({
        id: this.sharedSelected.id,
        payload: payloads,
      });

      // this.sharedSelected = null

      this.isLoading = false;
      if (res) {
        await this.filters(this.filter);
        this.sharedSelected = this.items.data.find(
          (data) => data.id === this.sharedSelected.id
        );
        let defaultShare = this.sharedSelected.contactTypes.filter((contact) =>
          contact.contacts.find((method) => method.default)
        );
        defaultShare.forEach((contact) => {
          this.contactSelected[contact.type_name] = contact.defaultContact;
        });
        this.$nextTick(() => {
          this.$refs.sharedModal.show();
        });

        this.$notify({
          group: "alert",
          title: "ส่งผลตรวจสำเร็จ",
          text: "ส่งผลตรวจไปยังเป้าหมายสำเร็จแล้ว",
          position: "bottom right",
          type: "success",
        });
        // this.contactSelected = {};
        // this.sharedSelected = null;
        // this.contactCheck = [];

        // this.$refs.sharedModal.hide();
      } else {
        this.$notify({
          group: "alert",
          title: "ส่งผลตรวจผิดพลาด",
          text: "โปรดติดต่อเจ้าหน้าที่",
          position: "bottom right",
          type: "error",
        });
        this.$refs.sharedModal.show();
      }
    },
    async getDataPerPage(pageNo) {
      this.$store.state.isLoading = true;
      this.filter.page_no = pageNo;
      await this.filters(this.filter);
      this.$store.state.isLoading = false;
    },
    isContactCheck(contactName, contactList) {
      return this.contactCheck.includes(contactName) && contactList.length > 0;
    },
    onSelectContact(val, methodName) {
      this.contactSelected[methodName] = val;
    },
    async printReport(id) {
      if (this.$store.state.isLoading) {
        return;
      }

      this.$store.state.isLoading = true;
      let permission = await this.permission("report", "can_print");

      let item = this.items.data.find((data) => data.id === id);
      let fileName = `${moment(item.order_date).format("DDMMY")}_LN${item.ln}`;

      if (permission) {
        // let url = `${process.env.VUE_APP_IP}storage/report/report_${fileName}/pdf/${fileName}.pdf?sync=${Math.random()}`

        let url = `${process.env.VUE_APP_IP}print-report/${id}/${fileName}.pdf`;

        // let res = axios.get(url)
        // console.log(res)
        // url = `${process.env.VUE_APP_IP}storage/report/report_${id}/pdf/report_${id}.pdf?sync=${Math.random()}`

        await this.$nextTick().then(async () => {
          await this.$nextTick().then(async () => {
            window.open(url);
            // printJS({printable:`${process.env.VUE_APP_IP}print/${id}`, type:'pdf', showModal:true})
            await this.countPrinted(id);
            this.filters(this.filter);
            this.$store.state.isLoading = false;
          });
        });
      }
      this.$store.state.isLoading = false;
    },
    async previewReport(id) {
      if (this.$store.state.isLoading) {
        return;
      }

      this.$store.state.isLoading = true;
      let permission = await this.permission("report", "can_print");

      let item = this.items.data.find((data) => data.id === id);
      let fileName = `${moment(item.order_date).format("DDMMY")}_LN${item.ln}`;

      if (permission) {
        let url = `${process.env.VUE_APP_IP}print-report/${id}/${fileName}.pdf`;
        await this.$nextTick().then(async () => {
          window.open(url);
        });
        this.$store.state.isLoading = false;
      }
      this.$store.state.isLoading = false;
    },
    checkAllShared(item) {
      let contactTypes = item.contactTypes;
      let sharedHistory = item.shared_history;

      let isAllShared = true;
      contactTypes.forEach((el) => {
        let found = sharedHistory.findIndex((shel) => {
          return shel.contact_type_id === el.id;
        });

        if (found < 0) {
          isAllShared = false;
        }
      });
      return isAllShared;
    },
    async goAnimalPage(id, hospitalId) {
      if (this.$store.state.isLoading) {
        return;
      }
      this.$store.state.isLoading = true;
      try {
        await this.setAnimalData(id);
        await this.setCustomerData(hospitalId);
      } catch (error) {
        this.$swal.fire("Error", error, "error");
        this.$store.state.isLoading = false;
        return;
      }

      this.$store.state.isLoading = false;

      this.goHistoryAnimalAdding();
    },
    async goHistoryAnimalAdding() {
      const addingCustomer = false;
      const addingAnimal = false;
      this.setAdding({ addingCustomer, addingAnimal });
      let routeData = this.$router.resolve({ name: "history-animal-adding" });
      window.open(routeData.href, "_blank");
      // this.$router.push({ name: "history-animal-adding" });
    },
    async goHospitalPage(hospitalId) {
      if (this.$store.state.isLoading) {
        return;
      }
      this.$store.state.isLoading = true;
      try {
        await this.setCustomerData(hospitalId);
      } catch (error) {
        this.$swal.fire("Error", error, "error");
        this.$store.state.isLoading = false;
        return;
      }

      this.$store.state.isLoading = false;
      this.goHistoryCustomerAdding();
    },
    goHistoryCustomerAdding() {
      const addingCustomer = false;
      const addingAnimal = false;
      this.setAdding({ addingCustomer, addingAnimal });
      let routeData = this.$router.resolve({ name: "history-customer-adding" });
      window.open(routeData.href, "_blank");
      // this.$router.push({ name: "history-customer-adding" });
    },
    async printSelectedHandler() {
      if (this.$store.state.isLoading) {
        return;
      }
      this.$store.state.isLoading = true;

      let permission = await this.permission("report", "can_print");

      if (permission) {
        if (this.multiPrintSelected.length <= 0) {
          this.$swal.fire("ผิดพลาด", "ไม่มีรายการเลือกในการพิมพ์", "error");
          this.$store.state.isLoading = false;
          return;
        }

        let selectedOrder = [];
        this.multiPrintSelected.forEach((idSelected) => {
          let order = this.items.data.find((d) => d.id == idSelected);
          if (order) {
            selectedOrder.push({
              id: order.id,
              order_date: order.order_date,
              ln: order.ln,
            });
          }
        });

        const payload = {
          orderList: selectedOrder,
        };

        this.multiprint(payload)
          .then((response) => {
            let pdfWindow = window.open("", "_blank");
            pdfWindow.document.write(
              "<iframe width='100%' height='100%' src='data:application/pdf;base64, " +
                encodeURI(response) +
                "'></iframe>"
            );
            this.$store.state.isLoading = false;
          })
          .catch((err) => {
            console.error(err.message);
            this.$store.state.isLoading = false;
          });
      }
      this.$store.state.isLoading = false;
    },
  },
  filters: {
    convertContactTypeName(val) {
      switch (val) {
        case "phone":
          return "โทรศัพท์";
        case "line_id":
          return "LINE";
        case "fax":
          return "FAX";
        case "email":
          return "E-mail";
      }
    },
  },
  watch: {
    contactCheck(newVal, oldVal) {
      oldVal.forEach((el) => {
        if (!newVal.includes(el)) {
          delete this.contactSelected[el];
          return;
        }
      });
    },
  },
};
</script>

<style scoped>
#form {
  background-color: #eaeced;
  padding: 5px;
  /* margin-left: 1px;
  margin-right: 1px;
  display: flex;
  flex-direction: column;
  justify-content: center; */
  /*height: 50px;*/
  /* padding: 0.5rem; */
}
.left {
  text-align: left;
}
.search-box {
  width: 80%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
}
.search {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
.select-box {
  margin: 0px 5px 0px 5px;
  width: 20vw;
}
.search-icon {
  align-self: center;
  margin: 0px 0px 0px 10px;
  color: black;
}
.flex {
  display: flex;
  margin-right: 10px;
  margin-left: 5px;
}
a {
  color: black;
  cursor: pointer;
}
.text-red {
  color: red;
}
.text-orange {
  color: orange;
}
.date-box {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 15.5vw;
}
.icon {
  cursor: pointer;
}
.color {
  border-radius: 50%;
  width: 15px;
  height: 15px;
  align-self: center;
  margin: 0 auto;
  justify-content: center;
}
.group-status {
  display: flex;
  margin-bottom: 5px;
}
.status {
  display: flex;
  margin-right: 20px;
}
.red {
  background-color: red;
}
.yellow {
  background-color: #ffe927;
}
.pink {
  background-color: pink;
}
.blue {
  background-color: #00d0ec;
}
.green {
  background-color: #48e100;
}
.gray {
  background-color: gray;
}
.orange {
  background-color: #fb822b;
}
.approve-btn {
  background-color: #009906;
  border: none;
}

.reject-btn {
  background-color: #e20000;
  border: none;
}
.bold {
  font-weight: bold;
}

.checkmark {
  top: 3px;
  left: 0px;
  height: 18px;
  width: 18px;
  margin-left: 0;
  margin-right: 0;
}
.emer-check-box {
  margin-bottom: 0px !important;
}
.check-box {
  padding-left: 25px;
  display: inline-block;
}

.emergency-box {
  display: flex;
  align-items: center;
}

.emer-datetime {
  padding: 15px;
  padding-left: 10px;
}
.loading {
  position: fixed;
  z-index: 999;
  height: 2em;
  width: 2em;
  overflow: visible;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

.loading:before {
  content: "";
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
}

.multiselect__tags {
  max-height: 150px !important;
}
.date-picker-style {
  height: calc(1.5em + 0.75rem + 2px);
}
</style>

<style>
.date-box {
  padding-top: 5px;
  padding-bottom: 5px;
  text-align: center;
}
</style>
